import React from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '../../shared/SectionTitle';
import SectionDescription from '../../shared/SectionDescription';
import RichEditor from '../../shared/RichEditor';

const EndOfReport = ({ value, onChange }) => {
  return (
    <div>
      <SectionTitle title="End of Report" key="endReportTitle" />
      <SectionDescription
        description="This text will display on the last page of this report"
        key="endReportDescription"
      />
      <RichEditor key="endOfReport" initValue={value} onChange={(value) => onChange('endOfReport', value)} />
      <SectionDescription
        className="mt-2"
        description="Only images uploaded from your local drive can be displayed in reports"
      />
    </div>
  );
};

EndOfReport.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default EndOfReport;



// WEBPACK FOOTER //
// src/components/reportContentLayout/EndOfReport/index.jsx